import React, { useState, useRef } from 'react'
import "./index.css";
import Timer from "../../timer/timer";
import Video from '../../video/video';
import Audio from '../../audio/audio';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: 'none',
        border: 'none',
    },
};

const FoodBuildingIntro = (props) => {
    const actorName = "ERIK";
    const actorTitle = "Ghost Chef";
    const playVideo = useRef(null);
    const playAudio = useRef(null);
    //const posterURL = './actors/Erik.png';

    const posterURL = './bgs/FoodBuildingBG.jpg';
    const timerRef = useRef(null);

    //modal

    const [gameOverModalIsOpen, setGameOverModalIsOpen] = useState(false);

    function openGameOverModal() {
        setGameOverModalIsOpen(true);
    }

    function closeGameOverModal() {
        timerRef.current(props.initialTimeOut);
        setGameOverModalIsOpen(false);
    }
    function restartGame() {
        setGameOverModalIsOpen(false);
        props.goToStep(null, 'LandingPage');

    }

    //modal end

    const gotoFailed = (event, args) => {
        if (gameOverModalIsOpen) {

        } else {
            openGameOverModal();
        }

    }

    const updateVideoStatue = (value) => {
      
        if (value === "ended") {
            props.goToStep(null, "FoodBuildGame");
        }

    }

    const updateAudioStatue = (value) => {
        
    }

    const setUpWarningSound = () => {
        if (playAudio.current) {
            playAudio.current('./musics/30SecondTimer.mp3');
        }
    }

    return (<>
        <div className="foodBuildingIntro">
            <div className='headerRow'>
                <div className='pgTitle'>
                <div className="gameTitleContainer">
                    <div className='pgName'>Food Building</div>
                    <div className='pgDesc'>Deep Fried Codebreaker</div>
                    </div>
                </div>
                <Timer seconds={props.seconds} gotoFailed={gotoFailed} isReversed={props.isReversed} setUpWarningSound={setUpWarningSound} timerRef={timerRef} updateTimerValue={props.updateTimerValue} />
            </div>
            <div className='introVideoContainer'>
                <Video VideoURL="./videos/4_1_Food_Building.mp4" actorName={actorName} actorTitle={actorTitle} poster={posterURL} updateVideoStatue={updateVideoStatue} playVideo={playVideo} />
            </div>
            <Modal
                isOpen={gameOverModalIsOpen}
                style={customStyles}
                contentLabel="Game over"
            >
                <div className="timeOutPopup">
                    <div className='timeoutContainer'>
                        <div className='timeoutLabel' />
                        <div className='paperContainer' />
                        <div className='timeoutPictures'>
                            <div className='pic1'></div>
                            <div className='pic2'></div>
                            <div className='pic3'></div>
                        </div>
                        <div className='timeoutMessage'>
                            Oops you've run out of time!
                        </div>
                        <div className='timoutButtonsContainer'>
                            <button className='timeoutButton' onClick={closeGameOverModal} >Continue?</button>
                            <button className='timeoutButton' onClick={restartGame}>Restart</button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Audio AudioURL="./musics/the-crackdown.mp3" autoPlay loop updateAudioStatue={updateAudioStatue} playAudio={playAudio} />
        </div>
    </>
    );
}

export default FoodBuildingIntro;